import React, { useMemo } from "react";
import "./genericLoader.css";

export function GenericLoaderComponent({
  size = 40, barWidth = 5, color = "#f47c21", absolute = false, className,
}) {
  const style = useMemo(() => ({
    height: `${size}px`,
    width: `${size}px`,
    borderWidth: barWidth,
    borderColor: color,
    borderTopColor: "rgba(0,0,0,0)",
  }), [size, barWidth, color]);
  return (
    <div className={`loader-wrapper ${absolute && "absolute-loading"} ${className}`}>
      <div className="generic-loader" style={style} />
    </div>
  );
}
